import { createSlice, PayloadAction } from '@reduxjs/toolkit'

export type RouteKeys =
  '/authentication/login' | 
  '/modulos' 


interface INavigationState {
  activeRoute: RouteKeys
}

const initialState: INavigationState = {
  activeRoute: '/modulos',
};

const navigationSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setActiveRoute(state, action: PayloadAction<{
      route: RouteKeys,
      params?: any
    }>) {
      state.activeRoute = action.payload.route
    }
  },
});

export const { setActiveRoute } = navigationSlice.actions;
export const navigationReducer = navigationSlice.reducer;